let dataConfig = {
  id: 'crossword',
  mainImage: {
    imagePath: 'games/page026_game4/img/plansza.png',
    width: 1920,
    height: 1080,
    pos: {
      x: 0,
      y: 0,
    },
  },
  inputWidth: 50,
  inputheight: 50,
  cssStyle: {
    left: '-60px',
    top: '190px',
    transform: 'scale(1.5, 1.5)',
  },
  sharedBlock: {
    listStyle: {
      unordered: true,
    },
    // cssStyle: {
    //   'top': '0px',
    //   'left': '0px',
    //   'height': '500px',
    //   'width': '500px',
    // }
  },
  caseSensitive: true,
  crossword: [
    {
      caseSensitive: true,
      pass: 'PAPUGA',
      // static: [{ index: 4 }],
      indx: 2,
      sel: 1,
    },
    {
      caseSensitive: true,
      pass: 'LEW',
      // static: [{ index: 4 }],
      indx: 3,
      sel: 0,
    },
    {
      caseSensitive: true,
      pass: 'FOKA',
      // static: [{ index: 1 }],
      indx: 3,
      sel: 0,
    },
    {
      caseSensitive: true,
      pass: 'SARNA',
      // static: [{ index: 4 }],
      indx: 2,
      sel: 1,
    },
    {
      caseSensitive: true,
      pass: 'BOCIAN',
      // static: [{ index: 1 }],
      indx: 3,
      sel: 0,
    },
    {
      caseSensitive: true,
      pass: 'DUDEK',
      // static: [{ index: 8 }],
      indx: 0,
      sel: 3,
    },
    {
      caseSensitive: true,
      pass: 'KOT',
      // static: [{ index: 8 }],
      indx: 1,
      sel: 2,
    },
  ],
};

export default dataConfig;
